import WHowRegister from './WHowRegister'

export default WHowRegister
